var map = {
	"./analytics.svg": "1476",
	"./arrow-small-bottom.svg": "d8e3",
	"./bonus.svg": "7808",
	"./calendar.svg": "51b0",
	"./call.svg": "5297",
	"./check-big.svg": "740b",
	"./check.svg": "2a3f",
	"./close-big.svg": "4090",
	"./close-small.svg": "5abb",
	"./close.svg": "3a0e",
	"./download.svg": "a334",
	"./email.svg": "b981",
	"./eye.svg": "99fe",
	"./headphones.svg": "067d",
	"./heart.svg": "13e6",
	"./home.svg": "67ef",
	"./leads.svg": "2bc9",
	"./logout.svg": "5201",
	"./menu-burger.svg": "17b5",
	"./message.svg": "1b57",
	"./missed-call.svg": "b5b0",
	"./not-paid.svg": "3c77",
	"./paid.svg": "6617",
	"./pause-filled.svg": "fe05",
	"./phone.svg": "cf12",
	"./play-filled.svg": "be51",
	"./push.svg": "509a",
	"./question.svg": "1f97",
	"./search.svg": "2d4a",
	"./small-error-filled.svg": "58bd",
	"./small-ok-filled.svg": "05bf",
	"./stats.svg": "8f2c",
	"./telegram.svg": "3330",
	"./transport.svg": "313a",
	"./video.svg": "b3fd",
	"./whatsApp.svg": "4cdd"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | icons */ "icons").then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "ddf2";
module.exports = webpackAsyncContext;